import type { CloudType } from "../types/cloud";

const CLOUD_SECTION_ROOTS: Record<CloudType, string> = {
  AWS: "/aws",
  GCP: "/gcp",
  AZURE: "/azure-directory",
};

export const getCloudAlertsPath = (cloud: CloudType): string =>
  `${CLOUD_SECTION_ROOTS[cloud]}/cloud-alerts`;

export const getPolicyAutopilotPath = (cloud?: CloudType | null): string =>
  cloud ? `${CLOUD_SECTION_ROOTS[cloud]}/policy-autopilot` : "/cloud/policy-autopilot";

export const getAlertManagementPath = (cloud?: CloudType | null): string =>
  cloud ? `${CLOUD_SECTION_ROOTS[cloud]}/cloud-alert-management` : "/cloud/cloud-alert-management";
